import React from "react"
import Slider from "react-slick"
import "./stamp-product.scss"
import useMediaQuery from "../../../shared/utils/useMediaQuery"

const StampProduct = ({ stamps }) => {

  const isMobile = useMediaQuery()

  const settingsSlider = {
    slidesToShow: isMobile ? 1 : stamps.length < 3 ? stamps.length : 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 6000,
    dots: true,
    focusOnSelect: true,
    dotsClass: "slick-dots f-custom-dots",
  }

  return (
    <section className="f-stamp-product-section">
      <div className="f-stamp-container">
        <Slider {...settingsSlider}>
          {stamps.map((stamp, index) => {
            return (
              <div key={index} className="f-stamp">
                <img
                  className="f-stamp__img"
                  src={stamp.sello.file.url}
                  alt={stamp.sello.description}
                />
                <h2 className="f-stamp__title">{stamp.titulo}</h2>
                <p className="f-stamp__description">
                  {stamp.descripcionDelSello.descripcionDelSello}
                </p>
              </div>
            )
          })}
        </Slider>
      </div>
    </section>
  )
}

export default StampProduct
